import { connect } from 'react-redux';

import { signUpStepsActions } from 'state/signUpSteps';

import Redirecting from './Redirecting';

const { RESET_SIGNUPSTEPS_STATE } = signUpStepsActions;

const mapDispatchToProps = {
  resetSignUpStepsState: RESET_SIGNUPSTEPS_STATE,
};

export default connect(null, mapDispatchToProps)(Redirecting);
